import { Flame, Gift, Moon, Mic, Laugh, Hammer, Music, Utensils, Palette, Ticket, Baby, Sparkles } from "lucide-react";

const ICON_MAP = {
  flame: Flame, gift: Gift, moon: Moon, mic: Mic, laugh: Laugh,
  hammer: Hammer, music: Music, utensils: Utensils, palette: Palette,
  ticket: Ticket, baby: Baby,
};

export default function CategoryChips({ categories, active, onChange, counts = {} }) {
  const items = [{ key: "all", name: "All Events", icon: "sparkles" }, ...categories];
  return (
    <div
      data-testid="category-chip-row"
      className="flex gap-3 overflow-x-auto hide-scrollbar pb-2 -mx-4 px-4"
    >
      {items.map((c) => {
        const Icon = ICON_MAP[c.icon] || Sparkles;
        const isActive = active === c.key;
        return (
          <button
            key={c.key}
            data-testid={`category-chip-${c.key}`}
            onClick={() => onChange(c.key)}
            className={`shrink-0 h-11 px-4 rounded-full inline-flex items-center gap-2 text-sm font-bold border transition-all ${
              isActive
                ? "bg-[#FA003F] text-white border-transparent shadow-[0_8px_24px_rgba(250,0,63,0.35)]"
                : "bg-white text-[#1A1A1A] border-black/10 hover:border-[#FA003F]/40 hover:bg-[#FA003F]/5"
            }`}
          >
            <Icon className="h-4 w-4" />
            <span>{c.name}</span>
            {typeof counts[c.key] === "number" && (
              <span
                className={`ml-1 text-[11px] font-black px-1.5 py-0.5 rounded-full ${
                  isActive ? "bg-white/25 text-white" : "bg-[#1A1A1A]/5 text-[#1A1A1A]/70"
                }`}
              >
                {counts[c.key]}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
